import api from "./api";

export const createReport = (data, token) => {
  return api.post("/reports/new", data, {
    headers: {
      authrization: token,
    },
  });
};
